import { render, staticRenderFns } from "./Mingye_Stage.vue?vue&type=template&id=21a1f98c&scoped=true"
import script from "./Mingye_Stage.vue?vue&type=script&lang=js"
export * from "./Mingye_Stage.vue?vue&type=script&lang=js"
import style0 from "./Mingye_Stage.vue?vue&type=style&index=0&id=21a1f98c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a1f98c",
  null
  
)

export default component.exports